import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DetailInfoRequest } from '@core/model/detail-info-request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { getHttpHeaders } from '@commons/utility/util';
import { UpdateDetailRequestType } from '@core/model';

@Injectable({
  providedIn: 'root',
})
export class AllianceDetailService {
  private apiUrl = environment.apiUrl;
  private detailUrl = `${this.apiUrl}alliance/detail/customer_alliance`;
  private canChangeFrontUrl = `${this.apiUrl}alliance/canChangeFront`;
  private updateDetailUrl = `${this.apiUrl}alliance/detail/update`;
  private encryptedUrl = `${this.apiUrl}alliance/encrypt`;
  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public getInfoDetail(detailInfoRequest: DetailInfoRequest): Observable<Map<string, string>> {
    return this.http
      .post(this.detailUrl, detailInfoRequest, {
        headers: this.headers,
      })
      .pipe(
        map((response: Map<string, string>) => {
          return response;
        })
      );
  }

  public canChangeFront(): Observable<boolean> {
    return this.http
      .get(this.canChangeFrontUrl, {
        headers: this.headers,
      })
      .pipe(
        map((response: boolean) => {
          return response;
        })
      );
  }

  canChangeFrontAlliance(allianCode: string): Observable<boolean> {
    const value = allianCode;
    return this.http
      .post(this.canChangeFrontUrl, value, {
        headers: this.headers,
      })
      .pipe(
        map((response: boolean) => {
          return response;
        })
      );
  }

  public updateDetail(updateDetailRequest: UpdateDetailRequestType): Observable<any> {
    return this.http.put(this.updateDetailUrl, updateDetailRequest, {
      headers: this.headers,
    });
  }

  public allianceEncrypted(value: string): Observable<string> {
    const requestOptions: Object = {
      responseType: 'text',
      headers: this.headers,
    };
    return this.http.post<string>(this.encryptedUrl, value, requestOptions);
  }
}
